import { render, staticRenderFns } from "./NotificationButton.vue?vue&type=template&id=cb2cf17c&"
import script from "./NotificationButton.vue?vue&type=script&lang=js&"
export * from "./NotificationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports